import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import { isAuthenticated } from 'utils/auth';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/welcome" state={{ from: location.pathname }} replace />;
  }

  return children;
}

AuthGuard.propTypes = { children: PropTypes.node };
